export default {
	idf_hors_paris: {
		titre: 'Contactez le 17 &ndash; Police secours',
		paragraphe1: 'Dans votre département, pour obtenir les coordonnées d’une <b>pharmacie de garde de nuit</b>, vous devez contacter la gendarmerie ou le commissariat proche de vous, via le 17 &ndash; Police secours.',
		paragraphe2: '<strong>Attention</strong> &ndash; En vous rendant à la pharmacie, n’oubliez pas de vous munir de votre ordonnance et de votre carte vitale.'
	},
	hors_idf: {
		titre: 'Information indisponible sur ameli.fr',
		paragraphe1: '<b>Pour des raisons de sécurité</b>, l\'information sur les pharmacies de garde de nuit n\'est pas disponible sur ameli.fr pour ce département. Nous vous invitons à consulter le site des Agences Régionales de Santé pour connaître les modalités de contact.',
		paragraphe2: '<b>Important</b> &ndash; Dans votre département, seules les pharmacies de garde de jour sont disponibles sur ameli.fr (soit les dimanches et jours fériés, en journée de 8h à 20h).'
	}
};
